import { Auth0Provider } from "@auth0/auth0-react"
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { NativeLayerProvider } from "./contexts/NativeLayerContext"
import reportWebVitals from "./reportWebVitals"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

const CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID
const DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN

if (!CLIENT_ID || !DOMAIN) {
    throw new Error("Missing Auth0 configuration")
}

root.render(
    <Auth0Provider
        domain={DOMAIN}
        clientId={CLIENT_ID}
        authorizationParams={{
            redirect_uri: window.location.origin,
        }}
    >
        <NativeLayerProvider>
            <App />
        </NativeLayerProvider>
    </Auth0Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
